import { render, staticRenderFns } from "./LeftSideBarNavigation.vue?vue&type=template&id=aa704d36&"
import script from "./LeftSideBarNavigation.vue?vue&type=script&lang=js&"
export * from "./LeftSideBarNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideBarNavigation.vue?vue&type=style&index=0&id=aa704d36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports